import {isHost, isPreview} from '~/ViewInvitation/utils';

export const useInviteName = ({guestName, origin}) => {
  let invitee;
  if (isHost() || isPreview()) {
    // host and preview should never see their name on envelope
    if (origin === 22) {
      invitee = window.guest?.name || "Recipient's name";
    } else {
      invitee = "Guest's Name";
    }
  } else if (guestName === 'AnonymousUser') {
    // for shareable links, display generic messages
    if (origin === 22) {
      invitee = 'Hello there!';
    } else {
      invitee = "You're Invited";
    }
  } else if (guestName && guestName !== ' ') {
    // if the user has a guest name, show it on envelope
    invitee = guestName;
  } else {
    // if no guest name is available, show a generic message
    invitee = 'Hello there!';
  }

  return invitee;
};
